import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { get, map, sortBy, filter } from "lodash";

import Grid from "@material-ui/core/Grid";

import InfoSection from "../../Common/InfoSection";
import MultipleInfoSection from "./MultipleInfoSection";

import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";

import { LANGUAGES } from "../../../constants/common";

import { formatPhone } from "../../../utils/form";
import { displayBoolean } from "../../../utils/data";
import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import { fetchGet } from "../../../api/fetch";

const HumanView = (props) => {

  const { section, data, lov, language, profileAttributes} = props;
  const [sensitive, setSensitive] = useState(false);

  useEffect(() => {
    let controller = new AbortController();
    (async () => {
      try {
        getProfile().then((dbUser) => {
          setSensitive(!dbUser.meta.pii_permission);
        })
        controller = null;
      } catch (e) {
        throw e;
      }
    })();
    return () => controller?.abort();
  },[])

  const getProfile = () => {
    return fetchGet("users/me"); // returns dbUser
  }
  
  const itemSizes = {
    xs: 6,
    sm: 3,
    md: 3,
    xl: 3,
  };

  if (section === "main") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) =>
          get(attr, ["active"]) &&
          get(attr, ["app_display_main_page"]) &&
          !get(attr, ["parent_sys_attribute_id"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );

    return (
      <>
        <Grid container style={{ maxWidth: "1100px" }}>
          <Grid item {...itemSizes}>
            <InfoSection
              title2={getAttributeName(31)}
              values={sensitive ? ["********"] : [getAttributeValue(data, 31)]}
            />
          </Grid>
          <Grid item {...itemSizes}>
            <InfoSection
              title2={getAttributeName(32)}
              values={sensitive ? ["********"] : [getAttributeValue(data, 32)]}
            />
          </Grid>
          <Grid item {...itemSizes}>
            <InfoSection
              title="tag"
              values={data.tag ? [data.tag[`name_${language}`]] : []}
              color={data.tag ? data.tag.color_rgb : ""}
            />
          </Grid>
          <Grid item {...itemSizes}>
            <MultipleInfoSection
              title2={getAttributeName(34)}
              values={map(getAttributeValues(data, 34), (item) => ({
                ...item,
                value: formatPhone(item.value),
              }))}
              typeId={194}
              language={language}
            />
          </Grid>
          <Grid item {...itemSizes}>
            <InfoSection
              title2={getAttributeName(195)}
              values={[getAttributeValue(data, 195)]}
            />
          </Grid>
          <Grid item {...itemSizes}>
            <InfoSection
              title2={getAttributeName(35)}
              values={[getAttributeValue(data, 35, lov)]}
            />
          </Grid>
          <Grid item {...itemSizes}>
            <InfoSection
              title2={getAttributeName(41)}
              values={[getAttributeValue(data, 41)]}
            />
          </Grid>
        </Grid>
        <Grid container style={{ maxWidth: "1100px" }}>
          {map(attributes, (attr) => (
            <Grid item key={attr.id} {...itemSizes}>
              <InfoSection
                title2={getAttributeName(attr.id)}
                values={[
                  attr.data_type === "boolean"
                    ? displayBoolean(
                        getAttributeValue(data, attr.id, lov, language)
                      )
                    : getAttributeValue(data, attr.id, lov, language),
                ]}
              />
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          style={{
            marginTop: "20px",
            maxWidth: "770px",
            backgroundColor: colors.lightGrey,
            paddingTop: "10px",
          }}
        >
          <Grid
            item
            className="flexCenter"
            style={{
              justifyContent: "center",
              width: "50px",
              marginBottom: "10px",
            }}
          >
            <img src={images.userLoginIcon} alt="user_login" />
          </Grid>
          <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title="username"
                values={[get(data, ["user", "username"])]}
              />
            </Grid>
          </Grid>
          <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(33)}
                values={[getAttributeValue(data, 33)]}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  if (section === "secondary") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) =>
          get(attr, ["active"]) &&
          !get(attr, ["app_display_main_page"]) &&
          !get(attr, ["parent_sys_attribute_id"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <Grid container style={{ maxWidth: "1100px" }}>
          <Grid item {...itemSizes}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(20)}
                values={[getAttributeValue(data, 20)]}
              />
              <InfoSection
                title2={getAttributeName(23)}
                values={[getAttributeValue(data, 23)]}
              />
              <InfoSection
                title2={getAttributeName(26)}
                values={[getAttributeValue(data, 26)]}
              />
              <InfoSection
                title2={getAttributeName(24)}
                values={[getAttributeValue(data, 24)]}
              />
              <InfoSection
                title2={getAttributeName(27)}
                values={[getAttributeValue(data, 27)]}
              />
            </Grid>
          </Grid>
          <Grid item {...itemSizes}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(39)}
                values={[getAttributeValue(data, 39)]}
              />
              <InfoSection
                title2={getAttributeName(36)}
                values={[getAttributeValue(data, 36, lov)]}
              />
              <InfoSection
                title2={getAttributeName(19)}
                values={[getAttributeValue(data, 19)]}
              />
            </Grid>
          </Grid>
          <Grid item {...itemSizes}>
            <Grid container direction="column">
              <MultipleInfoSection
                title2={getAttributeName(37)}
                values={getAttributeValues(data, 37)}
                typeId={133}
                language={language}
              />
              <MultipleInfoSection
                title2={getAttributeName(38)}
                values={getAttributeValues(data, 38)}
                typeId={134}
                language={language}
              />
              <MultipleInfoSection
                title2={getAttributeName(50)}
                values={getAttributeValues(data, 50)}
                typeId={135}
                language={language}
                noCheckmark
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container style={{ maxWidth: "1100px" }}>
          {map(attributes, (attr) => (
            <Grid item key={attr.id} {...itemSizes}>
              <InfoSection
                title2={getAttributeName(attr.id)}
                values={[
                  attr.data_type === "boolean"
                    ? displayBoolean(
                        getAttributeValue(data, attr.id, lov, language)
                      )
                    : getAttributeValue(data, attr.id, lov, language),
                ]}
              />
            </Grid>
          ))}
        </Grid>
      </>
    );
  }
  return null;
};

HumanView.propTypes = {
  section: PropTypes.oneOf(["main", "secondary"]).isRequired,
  data: PropTypes.object.isRequired,
  lov: PropTypes.object,
  language: PropTypes.oneOf(LANGUAGES),
};

export default HumanView;

// Save
// if (section === "main") {
//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <InfoSection
//             title="firstName"
//             values={[getAttributeValue(data, 31)]}
//           />
//           <InfoSection
//             title="lastName"
//             values={[getAttributeValue(data, 32)]}
//           />
//         </Grid>
//       </Grid>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <InfoSection
//             title="phoneNumber"
//             values={[formatPhone(getAttributeValue(data, 34))]}
//           />
//           <InfoSection title="email" values={[getAttributeValue(data, 33)]} />
//         </Grid>
//       </Grid>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <InfoSection
//             title="preferedLanguage"
//             values={[getAttributeValue(data, 35, lov)]}
//           />
//           <InfoSection
//             title="tag"
//             values={data.tag ? [data.tag[`name_${language}`]] : []}
//             color={data.tag ? data.tag.color_rgb : ""}
//           />
//         </Grid>
//       </Grid>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           {/* <InfoSection title="employer" values={[getAttributeValue(data, 40)]} /> */}
//           <InfoSection
//             title="employeeId"
//             values={[getAttributeValue(data, 41)]}
//           />
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }

// if (section === "secondary") {
//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <InfoSection
//             title="address1"
//             values={[getAttributeValue(data, 20)]}
//           />
//           <InfoSection title="city" values={[getAttributeValue(data, 23)]} />
//           <InfoSection
//             title="stateProvince"
//             values={[getAttributeValue(data, 26)]}
//           />
//           <InfoSection
//             title="postalCode"
//             values={[getAttributeValue(data, 24)]}
//           />
//           <InfoSection
//             title="country"
//             values={[getAttributeValue(data, 27)]}
//           />
//         </Grid>
//       </Grid>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <InfoSection
//             title="driverLicense"
//             values={[getAttributeValue(data, 39)]}
//           />
//           <InfoSection
//             title="preferedModeOfCommunication"
//             values={[getAttributeValue(data, 36, lov)]}
//           />
//         </Grid>
//       </Grid>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <MultipleInfoSection
//             title="rfid"
//             values={getAttributeValues(data, 37)}
//             typeId={133}
//             language={language}
//           />
//           <MultipleInfoSection
//             title="barcode"
//             values={getAttributeValues(data, 38)}
//             typeId={134}
//             language={language}
//           />
//         </Grid>
//       </Grid>
//       <Grid item xs={6} sm={4} md={3} xl={2}>
//         <Grid container direction="column">
//           <InfoSection
//             title="comments"
//             values={[getAttributeValue(data, 19)]}
//           />
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }